import { atom } from 'recoil';
import localStorageEffect from './localStorageEffect';

const isDarkThemeAtom = atom<boolean>({
  key: 'isDarkTheme',
  default: !!window.matchMedia?.('(prefers-color-scheme: dark)').matches,
  effects_UNSTABLE: localStorageEffect('isDarkTheme'),
});
export default isDarkThemeAtom;
